<template>
    <div class="cfy-dialog cont-sty publicpop">
        <el-row :gutter="40">
            <el-col :span="11">
                <div class="treebox">
                    <div class="lefttree">
                        <el-tree
                            :data="treeData"
                            show-checkbox
                            node-key="label"
                            ref="tree"
                            :default-expanded-keys="defaultChoose"
                            check-strictly
                            highlight-current
                            check-on-click-node
                            :load="loadNode"
                            lazy
                            :props="defaultProps" 
                            @check="oncheck"
                            @check-change="checkChangeTrueFale">
                        </el-tree>
                    </div>
                </div>
            </el-col>
            <el-col :span="11">
                <div class="treebox">
                    <p class="tit">已选择
                        <button class="clearbtn" @click="clearDialog" v-if="right.length > 0">清空</button>
                    </p>
                    <ul v-if="right" class="tree right-tree">
                        <li v-for="item in right" :key="item.label.label">
                            <span>{{item.label.label}}</span>
                            <i class="el-icon-circle-close" @click="delSel(item.label.label)"></i>
                        </li>
                    </ul>
                </div>
            </el-col>
            </el-row>
        <div class="btn_box">
            <button class="btn_canle" @click="closeDialog">取消</button>
            <button class="btn_sure" @click="confirmDialog">确定</button>
        </div>
    </div>
</template>

<script>
import {Form,Button,Input,Row,Col,Notification,Tree,Loading} from 'element-ui';
// 注释掉原有接口，改用模拟数据
// import { listpopularTypes } from '@/api/img.js'

export default {
    props:['msg'],
    data() {
        return {
            keyValue:null,
            treeData:null,
            choosedData:[],
            txt:null,
            classify:[],
            defaultProps: {
                children: 'children',
                label: 'label',
                isLeaf: `leaf`
            },
            right:[],
            defaultChoose:['01文学小说'],
        }
    },
    watch: {
        keyValue(){
            let vm = this;
            vm.queryStudyfyTree()
        }
    },
    mounted() {
        let vm = this;
        if(vm.msg){
            console.log(vm.msg,'vm.msg');
            let preArr = vm.msg.split('|'),
                arr1 = preArr[0].split(','),
                arr2 = preArr[1].split(',');
            vm.defaultChoose = arr2;
            arr2.forEach((ele,i) => {
                vm.classify.push({'label':ele});
                vm.right.push({
                    'label':{
                        'label':ele,
                        'typeCode':arr1[i]
                    }
                });
            });
        }
        vm.queryStudyfyTree('1');
    },
    components: {
        Form,Button,'el-input':Input,'el-row':Row,'el-col':Col,Notification,
        'el-tree':Tree,Loading
    },
    methods: {
        // 模拟接口返回数据的函数
        mockListpopularTypes(params) {
            // 一级分类（classifyLevel=1）
            const level1Data = [
                {
                    gid: 'g1',
                    typeCode: '01',
                    typeName: '文学小说',
                    leaf: 0, // 不是叶子节点，可展开
                    children: []
                },
                {
                    gid: 'g2',
                    typeCode: '02',
                    typeName: '历史传记',
                    leaf: 0,
                    children: []
                },
                {
                    gid: 'g3',
                    typeCode: '03',
                    typeName: '科普读物',
                    leaf: 0,
                    children: []
                }
            ];

            // 二级分类（根据gid返回）
            const level2DataMap = {
                'g1': [
                    {
                        gid: 'g1-1',
                        typeCode: '0101',
                        typeName: '中国小说',
                        leaf: 0,
                        children: []
                    },
                    {
                        gid: 'g1-2',
                        typeCode: '0102',
                        typeName: '外国小说',
                        leaf: 0,
                        children: []
                    }
                ],
                'g2': [
                    {
                        gid: 'g2-1',
                        typeCode: '0201',
                        typeName: '中国历史',
                        leaf: 0,
                        children: []
                    },
                    {
                        gid: 'g2-2',
                        typeCode: '0202',
                        typeName: '世界历史',
                        leaf: 0,
                        children: []
                    }
                ],
                'g3': [
                    {
                        gid: 'g3-1',
                        typeCode: '0301',
                        typeName: '自然科学',
                        leaf: 0,
                        children: []
                    },
                    {
                        gid: 'g3-2',
                        typeCode: '0302',
                        typeName: '社会科学',
                        leaf: 0,
                        children: []
                    }
                ]
            };

            // 三级分类（根据二级gid返回）
            const level3DataMap = {
                'g1-1': [
                    {
                        gid: 'g1-1-1',
                        typeCode: '010101',
                        typeName: '古典小说',
                        leaf: 1, // 叶子节点，不可展开
                        children: []
                    },
                    {
                        gid: 'g1-1-2',
                        typeCode: '010102',
                        typeName: '现代小说',
                        leaf: 1,
                        children: []
                    }
                ],
                'g1-2': [
                    {
                        gid: 'g1-2-1',
                        typeCode: '010201',
                        typeName: '欧洲小说',
                        leaf: 1,
                        children: []
                    },
                    {
                        gid: 'g1-2-2',
                        typeCode: '010202',
                        typeName: '美洲小说',
                        leaf: 1,
                        children: []
                    }
                ],
                'g2-1': [
                    {
                        gid: 'g2-1-1',
                        typeCode: '020101',
                        typeName: '古代史',
                        leaf: 1,
                        children: []
                    },
                    {
                        gid: 'g2-1-2',
                        typeCode: '020102',
                        typeName: '近代史',
                        leaf: 1,
                        children: []
                    }
                ],
                'g2-2': [
                    {
                        gid: 'g2-2-1',
                        typeCode: '020201',
                        typeName: '中世纪史',
                        leaf: 1,
                        children: []
                    },
                    {
                        gid: 'g2-2-2',
                        typeCode: '020202',
                        typeName: '近现代史',
                        leaf: 1,
                        children: []
                    }
                ],
                'g3-1': [
                    {
                        gid: 'g3-1-1',
                        typeCode: '030101',
                        typeName: '生物学',
                        leaf: 1,
                        children: []
                    },
                    {
                        gid: 'g3-1-2',
                        typeCode: '030102',
                        typeName: '物理学',
                        leaf: 1,
                        children: []
                    }
                ],
                'g3-2': [
                    {
                        gid: 'g3-2-1',
                        typeCode: '030201',
                        typeName: '经济学',
                        leaf: 1,
                        children: []
                    },
                    {
                        gid: 'g3-2-2',
                        typeCode: '030202',
                        typeName: '社会学',
                        leaf: 1,
                        children: []
                    }
                ]
            };

            return new Promise((resolve) => {
                // 模拟接口延迟
                setTimeout(() => {
                    let result = { data: [] };
                    // 根据参数返回对应层级数据
                    if (params.classifyLevel === '1') {
                        result.data = level1Data;
                    } else if (params.gid) {
                        // 二级数据
                        if (level2DataMap[params.gid]) {
                            result.data = [ { children: level2DataMap[params.gid] } ];
                        } 
                        // 三级数据
                        else if (level3DataMap[params.gid]) {
                            result.data = [ { children: level3DataMap[params.gid] } ];
                        }
                    }
                    resolve(result);
                }, 100);
            });
        },

        queryStudyfyTree(num) {
            let vm = this,params={};
            params = {
                classifyLevel: num,
                gid:'',
            };
            // 改用模拟数据函数
            this.mockListpopularTypes(params).then(res => {
                vm.treeData = res.data;
                vm.treeData.forEach(ele => {
                    ele.leaf = +ele.leaf ? true : false;
                })
                if(vm.treeData)vm.setCode(vm.treeData);
            }).catch(res => {
                Notification.error({title:'提示',message:res.msg || '操作失败请稍后再试！',duration:2000});
            })
        },
        // 异步树叶子节点懒加载逻辑
        loadNode(node, resolve) {
            // 一级节点处理
            if(node.level === 0) {
                return resolve([]);
            } else {
                this.getIndex(node, resolve);
            }
        },
        // 异步加载叶子节点数据函数
        getIndex(node, resolve) {
            let vm = this;
            if(!node.data.leaf) {
                node.leaf = true;
                let params = {
                    gid: node.data.gid
                }
                // 改用模拟数据函数
                this.mockListpopularTypes(params).then(res => {
                    let data = res.data[0].children || [];
                    // 处理节点是否是叶子节点
                    if(data && data.length > 0){
                        data.forEach(ele => {
                            ele.leaf = +ele.leaf ? true : false;
                        });
                        vm.setCode(data);
                    }
                    resolve(data);
                    vm.$nextTick(() => {
                        let classifyLabel = [];
                        vm.classify.forEach(ele => {
                            classifyLabel.push(
                                ele.label
                            )
                        });
                        vm.$refs.tree.setCheckedKeys(classifyLabel);
                    })
                });
            } else return resolve([]);
        },
        setCode(data){
            var vm = this;
            data.forEach( ele => {
                let label = `${ele.typeCode}${ele.typeName}`;
                vm.$set(ele,'label',label);
            });
        },
        checkChangeTrueFale(a, b, c) {
            if(b) {
                let ch = this.$refs.tree.getNode(a);
                // 调整层级循环（适配三级）
                if(ch.childNodes.length) {
                    ch.childNodes.forEach(ele => {
                        this.$set(ele.data, 'disabled', true);
                        if(ele.childNodes.length) {
                            ele.childNodes.forEach(subEle => {
                                this.$set(subEle.data, 'disabled', true);
                            })
                        }
                    });
                }
            } else {
                let ch = this.$refs.tree.getNode(a);
                if(ch.childNodes.length) {
                    ch.childNodes.forEach(ele => {
                        this.$set(ele.data, 'disabled', false);
                        if(ele.childNodes.length) {
                            ele.childNodes.forEach(subEle => {
                                this.$set(subEle.data, 'disabled', false);
                            })
                        }
                    });
                }
            }
        },
        delSel(dad){
            let vm = this,rightList = [],index=null;
            vm.right.forEach(ele => {
                rightList.push(ele.label.label);
            });
            index = rightList.indexOf(dad);
            if(index != -1) {
                rightList.splice(index, 1);
                vm.classify.splice(index, 1);
                vm.$refs.tree.setCheckedKeys([]);
                if(rightList.length > 0) vm.$refs.tree.setCheckedKeys(rightList);
            }
            vm.right.splice(index, 1);
        },
        oncheck(a, b){
            let vm = this;
            let thischeckStr = a.label 
            let thischeckArr = [{
                "label": {
                    "label": a.label,
                    "typeCode": a.typeCode
                }
            }];
            let rightArr = [];
            vm.right.forEach(ele => {
                rightArr.push(ele.label.label);
            });
            if(rightArr.indexOf(thischeckStr) != -1) {
                let thisRightArr = vm.right;
                let thisright = rightArr;
                let index = thisright.indexOf(thischeckStr);
                thisRightArr.splice(index, 1);
                vm.right = thisRightArr; 
                let checkArr = [];
                vm.right.forEach(ele => {
                    checkArr.push({
                        "label": ele.label.label,
                        "typeCode": ele.label.typeCode
                    })
                });
                vm.classify = checkArr; 
            }else{
                let thisrightyuy = [];
                thisrightyuy = vm.right;
                let newRight = thisrightyuy.concat(thischeckArr);
                vm.right = newRight; 
                let checkArr2 = [];
                vm.right.forEach(ele => {
                    checkArr2.push({
                        "label": ele.label.label,
                        "typeCode": ele.label.typeCode
                    })
                });
                vm.classify = checkArr2; 
            }
        },
        closeDialog(e, bool=false, txt=null) {
            let vm = this;
            vm.$emit('close');
        },
        confirmDialog() {
            let vm = this,len = vm.choosedData.length,dataArr=[],codesArr = [],dataStr=[],gids=[],labelArr=[],namedata=[],txt = vm.$refs.tree.getCheckedNodes();
            if(vm.right.length == 0){
                dataStr = '';
            }else{
                if(vm.right.length != txt.length) {
                    vm.right.forEach(ele => {
                        dataArr.push(ele.label.label);
                        codesArr.push(ele.label.typeCode);
                    });
                    dataStr = `${String(codesArr)}|${String(dataArr)}`;
                }else {
                    txt.forEach(ele => {
                        labelArr.push(ele.label);
                        codesArr.push(`${ele.typeCode}`);
                    });
                    dataStr = `${String(codesArr)}|${String(labelArr)}`;
                }
            }
            vm.$emit('ok',dataStr);
        },
        clearDialog() {
            let vm = this;
            vm.classify = [];
            vm.right = [];
            vm.$refs.tree.setCheckedKeys([]);
        }
    }
};
</script>

<style lang='scss'>
// 原有样式不变，这里省略（保持你原有样式即可）
    .publicpop .el-row .el-col .treebox .lefttree{
        height: 322px;;
    }

.search-wrap{
        padding: 15px;
      
        width: calc(100% - 30px);
       
        position: relative;
        margin-top:16px;
        background-color:#fff;
        position: relative;
        overflow: hidden;
      
        .drop_btn{
            position: absolute;
            display: block;
            line-height: 50px;
            padding: 0px 40px;
            cursor: pointer;
            bottom: 0px;
            right: 0px;
            color: #999;
        }
        .no-margin{
            margin:0 !important;
           
        }
        .el-input{
          
            width: 100%;
        }
        .el-input__inner{
            padding:0px 8px;
            
        }   
        .s-input{   
            float: left;
            width:75px;
            .el-form-item__content{
                .midbox{
                    width: 52px;
                }
            }      
            .el-input__inner{
                padding:0px 8px;
                width: 52px;
            }
        }
        .date-input{
            float: left;
            width:130px;
            .el-input__inner{
                padding:0px 8px;
                width: 128px;
            }
        }
        .el-input--prefix .el-input__inner{
            padding-left:25px;
        }
        .line{
            text-align: center;
        }
        .s-input{
            .el-input{
                width:70%;
            }
            i{
                font-style: normal;
            }
        }
        .el-form-item__label{
            padding-right:5px;
            font-size: 12px;
        }
        .search-btn{
            text-align: center;
            padding-top:15px;
        }       
        
        .labelwrap{
            position: relative;
            .circleclose{display: none}
            .el-form-item__content:hover .circleclose{
                position: absolute;
                cursor: pointer;
                top: 3px;
                right: 0px;
                height: 24px;
                line-height: 24px;
                width: 24px;
                text-align: center;
                color: #bcc0c5;
                display: block;
            }
        }
    }
    
    /* 分类弹框样式    //学科、大众 */
    .cont-sty{
     
        .el-col .treebox{
            width: 209px;
            height: 323px;
            padding: 15px 0 0 15px;
            padding-right:0px;
            margin:28px 0 0 38px;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #c9d7e8;
            .search-sty{
                .el-input__inner{
                    width: 200px;
                    height: 32px;
                    padding-left: 28px;
                    background-color: #fff;
                    border-radius: 16px;
                    height: 28px;
                    line-height: 28px;
                    border: solid 1px #b6d2e6;
                }
                .el-icon-search{
                    line-height: 32px;
                }
            }
            .lefttree{
                height: 291px;
                overflow: auto;
                list-style: none;
                .check-box{
                    cursor: pointer;
                    margin-top:10px;
                }
            }
            .tit{
                font-weight: bold;
                font-size: 13px;
            }
            .right-tree{
                width: 209px;
                height: 301px;
                overflow: auto;
                list-style: none;
                padding: 0px;
                >li{
                    cursor:pointer;
                    margin-top:10px;
                    span{
                        display: inline-block;
                        width: 170px;
                        font-size: 12px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    i{
                        font-size: 17px;
                        color:#bbc8d4;
                    }
                    &:hover i{
                        color:#1c7bd3;
                    }
                }
                >li:hover{
                    color: #1c7bd3;
                }
            }
            .noData{
                text-align: center;
                font-size: 12px;
                img{
                    height: 90px;
                    width: 70px;
                    margin: 30px auto 15px;
                    display: block;
                }
                .p{
                    margin: 4px;
                }
            }
            
        }    
    }
    .clearbtn {
        float: right;
        margin-right: 18px;
        width: 47px;
        height: 22px;
        line-height: 22px;
        background-color: #ffeaea;
        border-radius: 2px;
        border: 1px solid #f2c3c3;
        color: #ce4747;
        cursor: pointer;
    }
    .btnbase{
        border: 0px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        display:inline-block;
        height: 33px;
        line-height:33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }
    .btn_box{
        text-align: center;
        margin-top:15px;
        .btn_sure{
            @extend .btnbase ;
            color: #fff;
            background-color:#2c88f4;
        }
        .btn_canle{
            @extend .btnbase ;
            color:  #2c88f4;
            background-color:  #deefff;
        }
        .btn_green{
            @extend .btnbase ;
            color: #fff;
            background-color:#67c23a;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/publicPop.vue